import React from 'react';
import { blue_1200, white } from '@fiverr-private/sass/helpers';
import { translate } from '@fiverr-private/i18n-react';
import { BadgeProps } from '../../types';
import Badge from '../Badge';

import styles from './index.module.scss';

const FiverrChoiceBadge = ({
  showTooltip = true,
  tooltipPosition = 'top',
  dataTestId,
  appendTooltipToBody,
  disableTooltipFlip,
}: BadgeProps) => (
  <Badge
    showTooltip={showTooltip}
    color={white}
    backgroundColor={blue_1200}
    tooltipContent={translate('badges.fiverr_choice_badge.tooltip')}
    tooltipPosition={tooltipPosition}
    dataTestId={dataTestId}
    appendTooltipToBody={appendTooltipToBody}
    disableTooltipFlip={disableTooltipFlip}
  >
    <div className={styles.wrapper}>
      <p>Fiverr’s</p>
      <p className={styles.typographyGreen}>Choice</p>
    </div>
  </Badge>
);

FiverrChoiceBadge.displayName = 'FiverrChoiceBadge';

export default FiverrChoiceBadge;
